import { type InputTypeProps } from "@common/declarations";
import classNames from "classnames";
import React from "react";
import TextareaComponent from "react-textarea-autosize";
import withEnterModeHOC from "../withEnterMode";

import "./style.less";

type Props = InputTypeProps<string> & {
  addon?: any;
  minRows?: number;
  maxRows: number;
  placeholder?: string;
  onKeyDown: (e: React.KeyboardEvent) => void;
};
const TextAreaAutosizeBase = ({ addon, className, name, onChange, onKeyDown, style, ...props }: Props) => {
  const _onChange = React.useCallback(
    (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      onChange(e.target.value);
    },
    [onChange]
  );

  return (
    <div className={classNames("textarea auto_size", className, { disabled: props.isDisabled })} style={style}>
      <TextareaComponent
        {...props}
        disabled={props.isDisabled}
        onChange={_onChange}
        onKeyDown={onKeyDown}
        data-name={name}
      />

      {!!addon && <div className="addon">{addon}</div>}
    </div>
  );
};

const TextAreaAutosize = withEnterModeHOC<Props>(TextAreaAutosizeBase);

export default TextAreaAutosize;
